import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  Alert, AutoComplete, Checkbox, Popconfirm, Select,
} from 'antd';
import H3FormInput from '@Uilib/h3FormInput';
import SellerActions from '@Actions/sellerActions';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import H3Text from '@Uilib/h3Text';
import Helpers from '@Apis/helpers';
import { CountryCodes } from '@Apis/constants';
import CFV2Actions from '@Actions/configurations/cfV2Actions';
import CustomFieldV2 from '@Components/Common/CustomFieldV2';
import TenantActions from '@Actions/tenantActions';
import Crown from '@Images/crown2.png';
import CurrenciesActions from '@Actions/configurations/currenciesAction';
import CustomFieldHelpers from '@Helpers/CustomFieldHelpers';
import SelectPaymentTerm from '../SelectPaymentTerm';
import './style.scss';
import TenantCheckboxGroup from '../TenantCheckboxGroup';
import PRZSelect from '../UI/PRZSelect';

const { Option } = Select;

class VendorForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sellerName: '',
      gstin: '',
      pinCodeShipping: '',
      isMarketplaceSeller: false,
      isSubcontractor: false,
      isTransporter: false,
      districtShipping: '',
      addressShipping: '',
      stateShipping: '',
      phone: '',
      email: '',
      allTenantsSelected: true,
      showSelectedTenants: false,
      paymentTerms: 0,
      sellerTypes: ['REGISTERED', 'UNREGISTERED', 'OVERSEAS'],
      sellerType: 'UNREGISTERED',
    };
  }

  componentDidMount() {
    const {
      getDocCFV2, user, selectedSeller, isAdmin, getTenants, subcontractorForm, isMarketplaceSellerProp, getCurrencies
    } = this.props;
    const payload = {
      orgId: user?.tenant_info?.org_id,
      entityName: 'VENDORS',
    };
    getCurrencies();
    getDocCFV2(payload);
    getTenants(1, '', true, user?.tenant_info?.org_id, 100, () => { });
    if (selectedSeller && !isAdmin) {
      this.setState({
        selectedCurrencyID: selectedSeller?.currency_info?.org_currency_id,
        sellerName: selectedSeller?.seller_info?.seller_name,
        sellerType: selectedSeller?.seller_info?.seller_type,
        initialSellerType: selectedSeller?.seller_info?.seller_type,
        isMarketplaceSeller: selectedSeller?.seller_info?.is_marketplace_seller,
        isSubcontractor: selectedSeller?.seller_info?.is_subcontractor,
        isTransporter: selectedSeller?.seller_info?.is_transporter,
        contactPerson: selectedSeller?.seller_info?.contact_person_1,
        paymentTerms: selectedSeller?.seller_info?.default_payment_terms?.due_days,
        gstin: selectedSeller?.seller_info?.gst_number,
        pinCodeBilling: selectedSeller?.seller_info?.office_address_details?.postal_code,
        districtBilling: selectedSeller?.seller_info?.office_address_details?.city,
        addressBilling: selectedSeller?.seller_info?.office_address_details?.address1,
        stateBilling: selectedSeller?.seller_info?.office_address_details?.state,
        countryCode: String(selectedSeller?.seller_info?.dial_code) || Helpers.getDialCode(user?.tenant_info?.country_code),
        phone: selectedSeller?.seller_info?.mobile_1,
        email: selectedSeller?.seller_info?.email_id_1,
        bankAccountNo: selectedSeller?.seller_info?.bank_account_no,
        bankIfsc: selectedSeller?.seller_info?.bank_ifsc,
        bankName: selectedSeller?.seller_info?.bank_name,
        panNumber: selectedSeller?.seller_info?.pan,
        sellerId: selectedSeller?.seller_info?.seller_id,
        manufacturingAddressId: selectedSeller?.seller_info?.manufacturing_address_details?.manufacturing_address_id,
        officeAddressId: selectedSeller?.seller_info?.office_address_details?.office_address_id,
        faxNo: selectedSeller?.seller_info?.fax_no,
      });
    } else if (!isAdmin) {
      this.setState({ countryCode: Helpers.getDialCode(user?.tenant_info?.country_code) });
    }
    if (subcontractorForm) {
      this.setState({ isSubcontractor: true });
    }
    if (isMarketplaceSellerProp) {
      this.setState({ isMarketplaceSeller: isMarketplaceSellerProp });
    }
  }

  static getDerivedStateFromProps(props, state) {
    if (props.cfV2DocVendors && !state.isUserReadyForCF) {
      return {
        ...state,
        cfVendorsDoc: CustomFieldHelpers.getCfStructure(props.cfV2DocVendors?.data?.document_custom_fields, true) || [],
        isUserReadyForCF: true,
      };
    }
    if (props.user?.tenant_info?.org_default_currency_info?.org_currency_id && !state.isCurrencySelected && !props?.selectedSeller) {
      return {
        ...state,
        selectedCurrencyID: props.user?.tenant_info?.org_default_currency_info?.org_currency_id,
        isCurrencySelected: true,
      };
    }
    if (props.pincodeCity) {
      const city = props.pincodeCity;
      const cityState = props.pincodeState;
      props.setCityState(null, null);
      if (state.pinCodeShippingChange) {
        return {
          ...state, districtShipping: city, stateShipping: cityState, pinCodeShippingChange: false,
        };
      }

      return {
        ...state, districtBilling: city, stateBilling: cityState, pinCodeShippingChange: false,
      };
    }

    if (props.tenants && ((props?.selectedSeller && !state.selectedSeller) || (props?.selectedSeller && state.selectedSeller && props?.selectedSeller?.seller_id !== state?.selectedSeller?.seller_id)) && props.isAdmin) {
      const selectedTenants = [];
      for (let i = 0; i < props?.selectedSeller?.tenant_sellers?.length; i++) {
        selectedTenants.push(props?.selectedSeller?.tenant_sellers?.[i]?.tenant_id);
      }
      return {
        ...state,
        selectedCurrencyID: props?.selectedSeller?.currency_info?.org_currency_id,
        sellerName: props?.selectedSeller?.seller_name,
        isMarketplaceSeller: props?.selectedSeller?.is_marketplace_seller,
        contactPerson: props?.selectedSeller?.contact_person_1,
        gstin: props?.selectedSeller?.gst_number,
        countryCode: String(props?.selectedSeller?.dial_code) || Helpers.getDialCode(props?.user?.tenant_info?.country_code),
        phone: props?.selectedSeller?.mobile_1,
        email: props?.selectedSeller?.email_id_1,
        bankAccountNo: props?.selectedSeller?.bank_account_no,
        bankIfsc: props?.selectedSeller?.bank_ifsc,
        bankName: props?.selectedSeller?.bank_name,
        panNumber: props?.selectedSeller?.pan,
        sellerId: props?.selectedSeller?.seller_id,
        manufacturingAddressId: props?.selectedSeller?.manufacturing_address_details?.manufacturing_address_id,
        officeAddressId: props?.selectedSeller?.office_address_details?.office_address_id,
        allTenantsSelected: selectedTenants?.length === props?.tenants?.data?.length,
        selectedTenants,
        showSelectedTenants: false,
        selectedSeller: props?.selectedSeller,
        sellerType: props?.selectedSeller?.seller_type,
        initialSellerType: props?.selectedSeller?.seller_type,
        paymentTerms: props?.selectedSeller?.default_payment_terms?.due_days,
        isSubcontractor: props?.selectedSeller?.is_subcontractor,
        isTransporter: props?.selectedSeller?.is_transporter,
      };
    }
    if (props.tenants && !state.selectedTenants) {
      const selectedTenants = [];
      for (let i = 0; i < props?.tenants?.data?.length; i++) {
        selectedTenants.push(props?.tenants?.data?.[i]?.tenant_id);
      }
      return {
        ...state,
        selectedTenants,
      };
    }

    if (props?.selectedSeller) {
      if (props.cfV2DocVendors?.data?.success && !state.isUserReadyForCFInUpdate) {
        const oldCustomField = props?.selectedSeller?.custom_fields || [];

        return {
          ...state,
          cfVendorsDoc: CustomFieldHelpers.getDocumentCf(props.cfV2DocVendors?.data?.document_custom_fields, oldCustomField),
          isUserReadyForCFInUpdate: true,
        };
      }
    } else if (props.cfV2DocVendors && !state.isUserReady) {
      return {
        ...state,
        cfVendorsDoc: CustomFieldHelpers.getCfStructure(props.cfV2DocVendors?.data?.document_custom_fields, true) || [],
        isUserReady: true,
      };
    }
    return state;
  }


  addSeller = () => {
    this.setState({ formSubmitted: true });
    const {
      sellerName, gstin, pinCodeBilling, districtBilling, addressBilling, selectedCurrencyID,
      stateBilling, phone, email, panNumber, bankAccountNo, bankIfsc, countryCode, faxNo,
      bankName, contactPerson, cfVendorsDoc, paymentTerms, sellerType, isMarketplaceSeller, isSubcontractor, isTransporter,
    } = this.state;
    const {
      user, callback, history, createSeller, selectedSeller, updateSeller,
      tenants,
    } = this.props;

    if (this.isDataValid()) {
      if (selectedSeller) {
        const payload = {
          org_currency_id: selectedCurrencyID,
          seller_id: selectedSeller?.seller_id,
          seller_name: sellerName,
          alias_name: sellerName,
          gst_number: gstin,
          is_marketplace_seller: isMarketplaceSeller,
          is_subcontractor: isSubcontractor,
          is_transporter: isTransporter,
          email_id_1: email,
          contact_person_1: contactPerson,
          dial_code: countryCode,
          mobile_1: phone,
          pan: panNumber,
          bank_name: bankName,
          bank_branch_address: '',
          bank_account_type: '',
          bank_account_no: bankAccountNo,
          bank_ifsc: bankIfsc,
          logo: '',
          tenant_id: user?.tenant_info?.tenant_id,
          seller_status: 'ACTIVE',
          manufacturing_address_id: selectedSeller?.manufacturing_address_id,
          office_address_id: selectedSeller?.office_address_id,
          seller_type: sellerType,
          default_payment_terms: {
            advance_amount: 0,
            due_days: paymentTerms,
          },
          fax_no: faxNo
        };
        const tenantSellers = [];
        for (let i = 0; i < tenants?.data?.length; i++) {
          if (user?.tenant_info?.tenant_id === tenants?.data?.[i]?.tenant_id) {
            tenantSellers.push({
              tenant_id: tenants?.data?.[i]?.tenant_id,
              alias_name: sellerName,
              is_active: true,
              custom_fields: CustomFieldHelpers.postCfStructure(cfVendorsDoc),
            });
          }
          // else {
          //   tenantSellers.push({
          //     tenant_id: tenants?.data?.[i]?.tenant_id,
          //     alias_name: sellerName,
          //     is_active: tenants?.data?.[i]?.is_active,
          //     custom_fields: tenants?.data?.[i]?.custom_fields || [],
          //   });
          // }
        }
        payload.tenant_sellers = tenantSellers;
        updateSeller(payload, (createdSeller) => {
          if (callback) callback(createdSeller);
          else history.push('/purchase/vendors/manage');
        });
      } else {
        const tenantSellers = [];
        for (let i = 0; i < tenants?.data?.length; i++) {
          if (user?.tenant_info?.tenant_id === tenants?.data?.[i]?.tenant_id) {
            tenantSellers.push({
              tenant_id: tenants?.data?.[i]?.tenant_id,
              alias_name: sellerName,
              is_active: true,
              custom_fields: CustomFieldHelpers.postCfStructure(cfVendorsDoc),
            });
          } else {
            tenantSellers.push({
              tenant_id: tenants?.data?.[i]?.tenant_id,
              alias_name: sellerName,
              is_active: tenants?.data?.[i]?.is_active,

            });
          }
        }
        const payload = {
          seller_name: sellerName,
          alias_name: sellerName,
          description: '',
          gst_number: gstin,
          email_id_1: email,
          is_marketplace_seller: isMarketplaceSeller,
          is_subcontractor: isSubcontractor,
          is_transporter: isTransporter,
          contact_person_1: contactPerson,
          dial_code: countryCode,
          mobile_1: phone,
          pan: panNumber,
          bank_name: bankName,
          bank_branch_address: '',
          bank_account_type: '',
          bank_account_no: bankAccountNo,
          bank_ifsc: bankIfsc,
          logo: '',
          tenant_id: user?.tenant_info?.tenant_id,
          seller_status: 'ACTIVE',
          tenant_sellers: tenantSellers,
          seller_type: sellerType,
          default_payment_terms: {
            advance_amount: 0,
            due_days: paymentTerms,
          },
          custom_fields: CustomFieldHelpers.postCfStructure(cfVendorsDoc),
          org_currency_id: selectedCurrencyID,
          fax_no: faxNo
        };
        const addressRequired = user?.tenant_info?.purchase_config?.vendor?.settings?.address_required;
        if (addressRequired) {
          payload.manufacturing_address = {
            address1: addressBilling,
            address2: '',
            city: districtBilling,
            state: stateBilling,
            country: 'India',
            postal_code: pinCodeBilling,
          };
          payload.office_address = payload.manufacturing_address;
        }
        createSeller(payload, (createdSeller) => {
          if (callback) callback(createdSeller);
          else history.push('/purchase/vendors/manage');
        });
      }
    }
  }

  addSellerAdmin = () => {
    this.setState({ formSubmitted: true });
    const {
      sellerName, gstin, pinCodeBilling, districtBilling, addressBilling,
      stateBilling, phone, email, panNumber, bankAccountNo, bankIfsc, countryCode, selectedCurrencyID,
      bankName, contactPerson, selectedTenants, cfVendorsDoc, isMarketplaceSeller, isSubcontractor, isTransporter, faxNo
    } = this.state;
    const {
      tenants, callback, history, createSeller, user, isAdmin, updateSeller, selectedSeller,
    } = this.props;
    if (this.isDataValid()) {
      if (isAdmin && (!selectedSeller)) {
        const payload = {
          seller_name: sellerName,
          is_marketplace_seller: isMarketplaceSeller,
          is_subcontractor: isSubcontractor,
          is_transporter: isTransporter,
          alias_name: sellerName,
          description: '',
          gst_number: gstin,
          email_id_1: email,
          contact_person_1: contactPerson,
          dial_code: countryCode,
          mobile_1: phone,
          pan: panNumber,
          bank_name: bankName,
          bank_branch_address: '',
          bank_account_type: '',
          bank_account_no: bankAccountNo,
          bank_ifsc: bankIfsc,
          logo: '',
          seller_status: 'ACTIVE',
          custom_fields: CustomFieldHelpers.postCfStructure(cfVendorsDoc),
          org_currency_id: selectedCurrencyID,
          fax_no: faxNo
        };
        const tenantSellers = [];
        for (let i = 0; i < tenants?.data?.length; i++) {
          tenantSellers.push({
            tenant_id: tenants?.data?.[i]?.tenant_id,
            alias_name: sellerName,
            is_active: selectedTenants.includes(tenants?.data?.[i]?.tenant_id),
            custom_fields: CustomFieldHelpers.postCfStructure(cfVendorsDoc),
          });
        }
        payload.tenant_sellers = tenantSellers;
        const addressRequired = user?.tenant_info?.purchase_config?.sub_modules?.vendor?.settings?.address_required;
        if (addressRequired) {
          payload.manufacturing_address = {
            address1: addressBilling,
            address2: '',
            city: districtBilling,
            state: stateBilling,
            country: 'India',
            postal_code: pinCodeBilling,
          };
          payload.office_address = payload.manufacturing_address;
        }
        createSeller(payload, (createdSeller) => {
          if (callback) callback(createdSeller);
          else history.push('/purchase/vendors/manage');
        });
      } else {
        const payload = {
          org_currency_id: selectedCurrencyID,
          seller_id: selectedSeller?.seller_id,
          seller_name: sellerName,
          alias_name: sellerName,
          gst_number: gstin,
          email_id_1: email,
          contact_person_1: contactPerson,
          dial_code: countryCode,
          mobile_1: phone,
          pan: panNumber,
          bank_name: bankName || '',
          bank_branch_address: '',
          bank_account_type: '',
          bank_account_no: bankAccountNo || '',
          bank_ifsc: bankIfsc || '',
          logo: '',
          seller_status: 'ACTIVE',
          manufacturing_address_id: selectedSeller?.manufacturing_address_id,
          office_address_id: selectedSeller?.manufacturing_address_id,
          is_marketplace_seller: isMarketplaceSeller,
          is_subcontractor: isSubcontractor,
          is_transporter: isTransporter,
          fax_no: faxNo
        };
        const tenantSellers = [];
        for (let i = 0; i < tenants?.data?.length; i++) {
          tenantSellers.push({
            tenant_id: tenants?.data?.[i]?.tenant_id,
            alias_name: sellerName,
            is_active: selectedTenants.includes(tenants?.data?.[i]?.tenant_id),

          });
        }
        payload.tenant_sellers = tenantSellers;
        updateSeller(payload, (createdSeller) => {
          if (callback) callback(createdSeller);
          else history.push('/purchase/vendors/manage');
        });
      }
    }
  }

  isDataValid() {
    const {
      sellerName, gstin, phone, email, cfVendorsDoc, pinCodeBilling, districtBilling, addressBilling, stateBilling, sellerType,
    } = this.state;
    const { user, isAdmin} = this.props;
    const addressRequired = user?.tenant_info?.purchase_config?.vendor?.settings?.address_required;
    if (!sellerName
      || !sellerType
      || (phone && !Helpers.validatePhoneNumber(phone))
      || (email && !Helpers.validateEmail(email))
      || (sellerType === 'REGISTERED' ? !Helpers.validateGstNumber(gstin) : (gstin && !Helpers.validateGstNumber(gstin)))
      || (!isAdmin && cfVendorsDoc?.filter((customField) => customField.isRequired && customField.isActive && (customField?.fieldType === 'ATTACHMENT' ? !customField?.fieldValue?.length : !customField?.fieldValue))?.length)
      || (addressRequired && (!addressBilling || !districtBilling || !stateBilling || !pinCodeBilling)) || !sellerType
    ) return false;
    return true;
  }

  customInputChange(fieldValue, cfId) {
    const { cfVendorsDoc } = this.state;
    const newCustomField = cfVendorsDoc.map((customField) => {
      if (customField?.cfId === cfId) {
        if (customField?.fieldType === 'ATTACHMENT') {
          return {
            ...customField,
            fieldValue: fieldValue?.map((attachment) => ({
              url: attachment?.response?.response?.location || attachment?.url, type: attachment.type, name: attachment.name, uid: attachment.uid,
            })),

          };
        }
        return {
          ...customField,
          fieldValue,
        };
      }
      return {
        ...customField,
      };
    });
    this.setState({
      cfVendorsDoc: newCustomField,
    });
  }

  render() {
    const {
      getCityState, createSellerLoading, updateSellerLoading, getDocCFV2Loading, user, CurrenciesResults, getCurrenciesLoading,
      selectedSeller, isAdmin, tenants, subcontractorForm, searchSellersName, searchSellersNameResults, isMarketplaceSellerProp,
    } = this.props;
    const {
      sellerName, phone, email, addressBilling, allTenantsSelected,
      districtBilling, stateBilling, formSubmitted, pinCodeBilling, countryCode, selectedCurrencyID, faxNo,
      gstin, bankIfsc, bankAccountNo, bankName, cfVendorsDoc, selectedTenants,
      contactPerson, showSelectedTenants, paymentTerms, sellerTypes, sellerType, isMarketplaceSeller, isSubcontractor, isTransporter, initialSellerType
    } = this.state;
    const addressRequired = user?.tenant_info?.purchase_config?.vendor?.settings?.address_required;
    const vendor = user?.tenant_info?.purchase_config?.sub_modules?.vendor?.is_active;
    const restrictVendorGSTUpdate = user?.tenant_info?.purchase_config?.sub_modules?.vendor?.settings?.restrict_vendor_gst_update;
    

    const debouncedGetProducts = (value) => {
      // Clear the existing timer
      clearTimeout(this.timer);

      // Set a new timer for 1000 milliseconds (1 second)
      this.timer = setTimeout(() => {
        searchSellersName(value, user?.tenant_info?.tenant_id, '', 10, '', () => { }, true);
      }, 200);
    };

    return (
      <div>
        {getDocCFV2Loading ? (
          <div>
            <div className="ant-row">
              {[1, 2, 3, 4, 5, 6]?.map((item, index) => (
                <div key={item} className="ant-col-md-12 ant-col-xs-24">
                  <div className={(index % 2 === 0 ? 'orgInputContainer product__right-input' : 'orgInputContainer product__left-input')}>
                    <div className="loadingBlock" style={{ height: '15px', marginBottom: '6px' }} />
                    <div className="loadingBlock" style={{ height: '32px' }} />
                  </div>
                </div>
              ))}
            </div>
          </div>
        )
          : (
            <div className="vendor-form__wrapper">
              <div style={{ marginBottom: '40px' }}>
                <div className="ant-row">
                  <div className="ant-col-md-12 ant-col-xs-24">

                    <div className="orgInputContainer  create__right-input">
                      <label className="orgFormLabel">
                        Vendor Name
                        <span style={{ color: 'red' }}>{' *'}</span>
                      </label>
                      <AutoComplete
                        value={sellerName}
                        filterOption={false}
                        showSearch
                        onSearch={(value) => {
                          this.setState({ sellerName: value });
                          debouncedGetProducts(value);
                        }}
                        style={{
                          height: '28px',
                          width: '100%',
                          fontSize: '13px',
                        }}
                        disabled={createSellerLoading || updateSellerLoading}
                        maxLength={100}

                      >
                        {(sellerName && sellerName?.length > 3) && searchSellersNameResults?.sellers?.map((item) => (
                          <Option
                            key={item?.seller_info?.internal_slr_code}
                            value={item?.alias_name}
                          >
                            <div className="seller-filter__option">
                              <H3Text
                                text={`#${item?.seller_info?.internal_slr_code || ''}  ${item?.alias_name || ''}`}
                                className="seller-filter__option-text"
                              />
                            </div>
                          </Option>
                        ))}
                      </AutoComplete>
                      {formSubmitted && !sellerName && (
                        <div style={{
                          color: 'red', fontSize: '12px', marginTop: '4px', marginBottom: '5px',
                        }}
                        >
                          *Vendor name is required.
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="ant-col-md-12 ant-col-xs-24">
                    <div className="orgInputContainer  create__left-input">
                      <div className="orgFormLabel">
                        Vendor Type
                        <span style={{
                          color: 'red',
                          marginLeft: '2px',

                        }}
                        >
                          *
                        </span>

                      </div>
                      <div className="add-seller__form-type">
                        <PRZSelect
                          disabled={createSellerLoading || updateSellerLoading || (selectedSeller && initialSellerType === 'REGISTERED' && restrictVendorGSTUpdate && gstin)}
                          value={sellerType}
                          onChange={(value) => {
                            if (value === 'UNREGISTERED') {
                              this.setState({
                                gstin: '', sellerType: value,
                              });
                            }
                            this.setState({
                              sellerType: value,
                            });
                          }}
                        >
                          {sellerTypes?.map((type) => <Option key={type} value={type}>{type?.toProperCase()}</Option>)}

                        </PRZSelect>

                      </div>
                      {(formSubmitted && !sellerType) && (
                        <div className="input-error">
                          *Please enter seller type
                        </div>
                      )}
                    </div>

                  </div>
                  <div className="ant-col-md-12 ant-col-xs-24">
                    <H3FormInput
                      name="contact person name"
                      type="text"
                      containerClassName="orgInputContainer create__right-input"
                      labelClassName="orgFormLabel"
                      inputClassName="orgFormInput"
                      placeholder=""
                      disabled={createSellerLoading || updateSellerLoading}
                      onChange={(event) => this.setState({ contactPerson: event.target.value })}
                      value={contactPerson}
                      label="Contact Person Name"
                      maxlength="50"
                    />
                  </div>
                  <div className="ant-col-md-12 ant-col-xs-24">
                    <div className="orgInputContainer create__left-input">
                      <H3Text
                        text="Phone"
                        className="orgFormLabel"
                      />
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <PRZSelect
                          value={countryCode}
                          showSearch
                          filterOption={(input, option) => {
                            const { label } = option.props;
                            const { value } = option.props;
                            return (
                              label.toLowerCase().includes(input.toLowerCase())
                              || value.toLowerCase().includes(input.toLowerCase())
                            );
                          }}
                          onChange={(value) => this.setState({ countryCode: value })}
                          className={formSubmitted && !countryCode ? "prz-select__error-border" : ""}
                          style={{
                            borderRight: 'none',
                            borderRadius: '2px',
                            height: '28px',
                            width: '135px',
                            fontSize: '13px',
                          }}
                          disabled={createSellerLoading || updateSellerLoading}
                        >
                          {CountryCodes?.map((item) => (
                            <Option
                              key={item?.name}
                              value={item?.dial_code}
                              label={item?.name}
                            >
                              {`${item?.flag} +${item?.dial_code}`}
                            </Option>
                          ))}
                        </PRZSelect>
                        <H3FormInput
                          type="text"
                          containerClassName=" create__right-right-input"
                          labelClassName="orgFormLabel"
                          inputClassName="orgFormInput"
                          placeholder=""
                          onChange={(event) => this.setState({ phone: event.target.value })}
                          value={phone}
                          disabled={createSellerLoading || updateSellerLoading}
                          maxlength="50"
                        />
                      </div>
                      {(formSubmitted && phone && !Helpers.validatePhoneNumber(phone)) && (
                        <div className="input-error">
                          *Please enter valid phone number
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="ant-col-md-12 ant-col-xs-24">
                    <H3FormInput
                      name="a valid email"
                      type="text"
                      containerClassName="orgInputContainer create__right-input"
                      labelClassName="orgFormLabel"
                      inputClassName="orgFormInput"
                      placeholder=""
                      onChange={(event) => this.setState({ email: event.target.value })}
                      value={email}
                      disabled={createSellerLoading || updateSellerLoading}
                      label="Email"
                      maxlength="50"
                      showError={formSubmitted && (email && !Helpers.validateEmail(email))}
                    />
                  </div>
                  <div className="ant-col-md-12 ant-col-xs-24">
                    <H3FormInput
                      name="a valid email"
                      type="number"
                      containerClassName="orgInputContainer create__left-input"
                      labelClassName="orgFormLabel"
                      inputClassName="orgFormInput"
                      placeholder=""
                      onChange={(event) => this.setState({ faxNo: event.target.value })}
                      value={faxNo}
                      disabled={createSellerLoading || updateSellerLoading}
                      label="Fax"
                      maxlength="12"
                    />
                  </div>
                  <div className="ant-col-md-12 ant-col-xs-24 vendor-form__payment-terms">
                    <SelectPaymentTerm
                      selectedPaymentTerm={paymentTerms}
                      onChange={(value) => {
                        this.setState({ paymentTerms: value?.due_days });
                      }}
                      callback={(value) => {
                        this.setState({ paymentTerms: Number(value) });
                      }}
                      containerClassName="create__right-input"
                      labelClassName="orgFormLabel"
                      inputClassName="add-seller__form-selector"
                      showError={formSubmitted && !paymentTerms}
                      disabled={createSellerLoading || updateSellerLoading}
                      showAddPaymentTerm
                      placeholder="Select Payment Term"
                    />
                  </div>
                  <div className="ant-col-md-12 ant-col-xs-24">
                    <div className="orgInputContainer  create__left-input">
                      <div className="orgFormLabel">
                        Currencies
                        <span style={{
                          color: 'red',
                          marginLeft: '2px',
                        }}
                        >
                          *
                        </span>

                      </div>
                      <div className="add-seller__form-type">
                        <PRZSelect
                          onChange={(value) => {
                            this.setState({
                              selectedCurrencyID: value,
                            });
                          }}
                          value={selectedCurrencyID}
                          className="create__right-input"
                          disabled={(selectedSeller?.ledger_count||0)!==0}
                          loading={getCurrenciesLoading}
                          options={CurrenciesResults?.map((currency) => ({
                            value: currency?.org_currency_id, // Use a unique identifier as the value
                            label: `${currency.currency_code} (${currency.currency_symbol})`,
                          }))}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="ant-col-md-12 ant-col-xs-24">
                    {sellerType !== 'UNREGISTERED' && (
                      <H3FormInput
                        name="a valid GST number"
                        type="text"
                        containerClassName="orgInputContainer create__right-input"
                        labelClassName="orgFormLabel"
                        inputClassName="orgFormInput"
                        placeholder=""
                        onChange={(event) => this.setState(
                          { gstin: event.target.value, panNumber: event.target.value?.substr(2, 10) },
                        )}
                        required={sellerType === 'REGISTERED'}
                        disabled={createSellerLoading || updateSellerLoading || (selectedSeller  && initialSellerType ==='REGISTERED' && restrictVendorGSTUpdate)}
                        value={gstin}
                        showError={(sellerType === 'REGISTERED') ? (formSubmitted && !Helpers.validateGstNumber(gstin)) : (formSubmitted && gstin && !Helpers.validateGstNumber(gstin))}
                        label="GST Number"
                      />
                    )}

                  </div>
                  <div className="ant-col-md-12" />
                  <div className="ant-col-md-12" />
                  {user?.tenant_info?.production_config?.sub_modules?.manufacturing_order?.is_active && (
                    <div className="ant-col-md-12 ant-col-xs-24">
                      <div className="orgInputContainer product-form__left-input">
                        <Checkbox disabled={createSellerLoading || updateSellerLoading || subcontractorForm} checked={isSubcontractor} onChange={() => { this.setState({ isSubcontractor: !isSubcontractor }); }}>
                          <div className="">Manufacturing Sub Contractor</div>
                        </Checkbox>
                      </div>
                    </div>
                  )}
                  <div className="ant-col-md-12 ant-col-xs-24" />
                  <div className="ant-col-md-12 ant-col-xs-24">
                    <div className="orgInputContainer product-form__left-input">
                      <Checkbox disabled={createSellerLoading || updateSellerLoading || subcontractorForm} checked={isTransporter} onChange={() => { this.setState({ isTransporter: !isTransporter }); }}>
                        <div className="">Transporter</div>
                      </Checkbox>
                    </div>
                  </div>
                  <div className="ant-col-md-12 ant-col-xs-24" />
                  {user?.tenant_info?.global_config?.settings?.marketplace_enabled && (
                    <div className="ant-col-md-12 ant-col-xs-24">
                      <div className="orgInputContainer product-form__left-input">
                        <Checkbox disabled={createSellerLoading || updateSellerLoading || isMarketplaceSellerProp} checked={isMarketplaceSeller} onChange={() => { this.setState({ isMarketplaceSeller: !isMarketplaceSeller }); }}>
                          <div className="">Marketplace Seller</div>
                        </Checkbox>
                      </div>
                    </div>
                  )}
                  {selectedSeller && isMarketplaceSeller && (
                    <div className="add-product-disclaimer-wrapper">
                      <Alert
                        message="Warning: Upgrading to a marketplace seller will delete all previously created products in the particular vendor "
                        type="info"
                        showIcon
                        className=""
                      />
                    </div>
                  )}
                  {addressRequired && (
                    <Fragment>
                      <div className="ant-col-md-24">
                        <div className="add-seller__form-section">Address</div>
                      </div>
                      <div className="ant-col-md-24">
                        <H3FormInput
                          name="address"
                          type="text"
                          containerClassName="orgInputContainer"
                          labelClassName="orgFormLabel"
                          inputClassName="orgFormInput"
                          placeholder=""
                          onChange={(event) => this.setState({ addressBilling: event.target.value })}
                          value={addressBilling}
                          label="Street"
                          disabled={createSellerLoading || updateSellerLoading}
                          required={addressRequired}
                          showError={formSubmitted && !addressBilling}
                        />
                      </div>
                      <div className="ant-col-md-8">
                        <H3FormInput
                          name="a valid pincode"
                          type="number"
                          containerClassName="orgInputContainer create__right-input"
                          labelClassName="orgFormLabel"
                          inputClassName="orgFormInput"
                          placeholder=""
                          onChange={(event) => (event.target.value.length <= 6 ? this.setState({ pinCodeBilling: event.target.value }) : '')}
                          onBlur={(event) => (event.target.value.length <= 6 ? getCityState(event.target.value) : '')}
                          value={pinCodeBilling}
                          label="Pin Code"
                          disabled={createSellerLoading || updateSellerLoading}
                          required={addressRequired}
                          showError={formSubmitted && !pinCodeBilling}
                        />
                      </div>
                      <div className="ant-col-md-8">
                        <H3FormInput
                          name="district"
                          type="text"
                          containerClassName="orgInputContainer create__mid-input"
                          labelClassName="orgFormLabel"
                          inputClassName="orgFormInput"
                          placeholder=""
                          onChange={(event) => this.setState({ districtBilling: event.target.value })}
                          value={districtBilling}
                          label="District"
                          disabled={createSellerLoading || updateSellerLoading}
                          required={addressRequired}
                          showError={formSubmitted && !districtBilling}
                        />
                      </div>
                      <div className="ant-col-md-8">
                        <H3FormInput
                          name="state"
                          type="text"
                          containerClassName="orgInputContainer create__left-input"
                          labelClassName="orgFormLabel"
                          inputClassName="orgFormInput"
                          placeholder=""
                          onChange={(event) => this.setState({ stateBilling: event.target.value })}
                          value={stateBilling}
                          label="State"
                          disabled={createSellerLoading || updateSellerLoading}
                          required={addressRequired}
                          showError={formSubmitted && !stateBilling}
                        />
                      </div>
                    </Fragment>
                  )}
                  <div className="ant-col-md-24">
                    <div className="add-seller__form-section">Payment Information</div>
                  </div>
                  <div className="ant-col-md-12 ant-col-xs-24">
                    <H3FormInput
                      name="account holder name"
                      type="text"
                      containerClassName="orgInputContainer create__right-input"
                      labelClassName="orgFormLabel"
                      inputClassName="orgFormInput orgFormMarginRight"
                      placeholder=""
                      disabled={createSellerLoading || updateSellerLoading}
                      onChange={(event) => this.setState({ bankName: event.target.value })}
                      value={bankName}
                      label="Account Name"
                    />
                  </div>
                  <div className="ant-col-md-12 ant-col-xs-24">
                    <H3FormInput
                      name="account number"
                      type="number"
                      containerClassName="orgInputContainer create__left-input"
                      labelClassName="orgFormLabel"
                      inputClassName="orgFormInput"
                      placeholder=""
                      disabled={createSellerLoading || updateSellerLoading}
                      onChange={(event) => this.setState({ bankAccountNo: event.target.value })}
                      value={bankAccountNo}
                      label="Account Number"
                    />
                  </div>
                  <div className="ant-col-md-12 ant-col-xs-24">
                    <H3FormInput
                      name="ifsc code"
                      type="text"
                      containerClassName="orgInputContainer create__right-input"
                      labelClassName="orgFormLabel"
                      inputClassName="orgFormInput orgFormMarginRight"
                      placeholder=""
                      disabled={createSellerLoading || updateSellerLoading}
                      onChange={(event) => this.setState({ bankIfsc: event.target.value })}
                      value={bankIfsc}
                      label="IFSC Code"
                    />
                  </div>

                  <div className="ant-col-md-12 ant-col-xs-24" />
                  {!(selectedSeller && isAdmin) && cfVendorsDoc?.length > 0 && (
                    <CustomFieldV2
                      customFields={cfVendorsDoc || []}
                      formSubmitted={formSubmitted}
                      customInputChange={(value, cfId) => this.customInputChange(value, cfId)}
                      disableCase={createSellerLoading || updateSellerLoading}
                      isUpdate={!!selectedSeller}
                    />
                  )}
                  {isAdmin && (
                    <div className="ant-col-md-24">
                      <div className="add-product__tenant-list-wrapper">
                        <div className="add-product__tenant-list-title">
                          <Checkbox
                            onChange={() => {
                              if (!allTenantsSelected) {
                                const defaultSelectedTenants = [];
                                for (let i = 0; i < tenants?.data?.length; i++) {
                                  defaultSelectedTenants.push(tenants?.data?.[i]?.tenant_id);
                                }
                                this.setState({ allTenantsSelected: !allTenantsSelected, selectedTenants: defaultSelectedTenants });
                              } else {
                                this.setState({ allTenantsSelected: !allTenantsSelected, selectedTenants: [] });
                              }
                            }}
                            checked={allTenantsSelected}
                          />
                          <div className="add-product__tenant-list-title-text">
                            All Business Units
                            <span
                              onClick={() => this.setState({ showSelectedTenants: !showSelectedTenants })}
                            >
                              {showSelectedTenants ? "Show less" : "Show all"}
                            </span>
                          </div>
                        </div>
                        {(showSelectedTenants) && (
                          <TenantCheckboxGroup
                            tenants={tenants}
                            onChange={(value) => {
                              this.setState({ selectedTenants: value, allTenantsSelected: value?.length === tenants?.data?.length });
                            }}
                            selectedValues={selectedTenants}
                          />
                        )}
                      </div>
                    </div>
                  )}

                </div>
                <div className="custom-drawer__footer">
                  <div className="ant-col-md-6" style={{ marginTop: '0.5rem' }}>
                    <div className="indent-barcode__wrapper" style={{ display: 'flex' }}>
                      <H3Button
                        buttonType={defaultButtonTypes.BLUE_ROUNDED}
                        text={selectedSeller ? 'Update Vendor' : 'Add Vendor'}
                        onClick={() => (!isAdmin ? this.addSeller() : this.addSellerAdmin())}
                        isLoading={createSellerLoading || updateSellerLoading}
                        disabled={createSellerLoading || updateSellerLoading || !vendor}
                        style={{
                          width: '160px',
                          borderRadius: '5px',
                          padding: '7px 0px',
                          marginLeft: '0',
                        }}
                      />
                      {!vendor && (
                        <Popconfirm
                          placement="topRight"
                          title="This feature is not accessible within your current plan to use this feature contact us."
                          onConfirm={() => window.Intercom('showNewMessage')}
                          okText="Contact Us"
                          cancelText="Cancel"
                        >
                          <img
                            className="barcode-restrict"
                            src={Crown}
                            alt="premium"
                            style={{
                              marginLeft: '8px',
                              marginTop: '5px',
                            }}
                          />
                        </Popconfirm>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
      </div>
    );
  }
}
const mapStateToProps = ({
  UserReducers, SellerReducers, TenantReducers, CFV2Reducers, CurrenciesReducers
}) => ({
  user: UserReducers.user,
  cityStateLoading: SellerReducers.cityStateLoading,
  pincodeCity: SellerReducers.pincodeCity,
  pincodeState: SellerReducers.pincodeState,
  setCityStateError: SellerReducers.setCityStateError,
  createSellerLoading: SellerReducers.createSellerLoading,
  tenants: TenantReducers.tenants,
  getDocCFV2Loading: CFV2Reducers.getDocCFV2Loading,
  cfV2DocVendors: CFV2Reducers.cfV2DocVendors,
  updateSellerLoading: SellerReducers.updateSellerLoading,
  CurrenciesResults: CurrenciesReducers.CurrenciesResults,
  searchSellersNameResults: SellerReducers.searchSellersNameResults,
});

const mapDispatchToProps = (dispatch) => ({
  setCityState: (city, state) => dispatch(SellerActions.setCityState(city, state)),
  getCityState: (pincode) => dispatch(SellerActions.getCityState(pincode)),
  createSeller: (payload, callback) => dispatch(SellerActions.createSeller(payload, callback)),
  getDocCFV2: (payload, callback) => dispatch(CFV2Actions.getDocCFV2(payload, callback)),
  getDocCFV2Success: (customFields) => dispatch(CFV2Actions.getDocCFV2Success(customFields)),
  updateSeller: (payload, callback) => dispatch(SellerActions.updateSeller(payload, callback)),
  getCurrencies: (orgId) => dispatch(CurrenciesActions.getCurrencies(orgId)),
  getTenants: (page, keyword, isVerified, orgId, limit, callback) => dispatch(TenantActions.getTenants(page, keyword, isVerified, orgId, limit, callback)),
  searchSellersName: (keyword, tenantId, page, limit, sellerId, callback, isActive, isSubcontractor, sellerType) => dispatch(SellerActions.searchSellersName(keyword, tenantId, page, limit, sellerId, callback, isActive, isSubcontractor, sellerType)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(VendorForm));
